import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type MainWrapperProps = Readonly<{
  children: ReactNode;
  className?: string;
}>;

export default function MainWrapper({ children, className }: MainWrapperProps) {
  return (
    <div
      data-testid="wrapper-block"
      className={twMerge("max-w-7xl mx-auto bg-white", className)}
    >
      {children}
    </div>
  );
}
